import React, { Fragment, useState } from 'react'
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom'
import { markAsCommissionedAction } from '../../redux/actions/orderActions';

const SingleOrderButtons = ({ order, user }) => {
    const dispatch = useDispatch();
    const [showPopup, setShowPopup] = useState(false);
    const [actionToPerform, setActionToPerform] = useState('');
    const [popupHeading, setpopupHeading] = useState('');
    const [popupPara, setpopupPara] = useState('');

    const handleDispatch = () => {
        if (actionToPerform === "COMMISSIONED") {
            dispatch(markAsCommissionedAction({ order_id: order?.id }));
            setShowPopup(false);
        }
    }

    const handleMarkAsCommissioned = () => {
        setShowPopup(true);
        setActionToPerform("COMMISSIONED")
        setpopupHeading("Mark as Commissioned")
        setpopupPara(`By marking this order as Commissioned, you confirm that the order has been successfully completed and the commission can be processed. Please ensure all necessary steps have been taken and the order is ready for commissioning before proceeding.`)
    }

    return (
        <Fragment>
            <div className="flex items-center gap-[0.5vmax] justify-center flex-1">
                <Link to={`/orders/order-details?order_id=${order?.id}`} className="flex-1 inline-flex items-center justify-center px-3 py-1.5 text-sm font-semibold rounded-lg bg-blue-50 text-blue-600 border border-blue-200 hover:bg-blue-100 transition-all whitespace-nowrap">
                    View
                </Link>
                {user?.role !== "PM" && (
                    <button onClick={handleMarkAsCommissioned} className="flex-1 inline-flex items-center justify-center px-3 py-1.5 text-sm font-semibold rounded-lg bg-amber-50 text-amber-600 border border-amber-200 hover:bg-amber-100 transition-all whitespace-nowrap">
                        Commissioned
                    </button>
                )}
            </div>

            {showPopup && (
                <div className="fixed inset-0 flex items-center justify-center bg-zinc-900/50 backdrop-blur-sm z-[99999999999] p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden border border-zinc-100 p-6">
                        <div className="mx-auto w-12 h-12 rounded-full flex items-center justify-center text-2xl mb-4 bg-indigo-50 text-indigo-600">
                            <i className="fa-solid fa-circle-question"></i>
                        </div>
                        <div className="text-center">
                            <h3 className="font-bold text-lg text-zinc-800 mb-2">{popupHeading}</h3>
                            <p className="text-sm text-zinc-500 leading-relaxed whitespace-pre-line">{popupPara}</p>
                        </div>
                        <div className="flex gap-3 mt-6">
                            <button className="flex-1 text-zinc-600 font-semibold py-2.5 px-4 rounded-xl border border-zinc-200 hover:bg-zinc-50 transition-all" onClick={() => setShowPopup(false)}>
                                No
                            </button>
                            <button className="flex-1 font-semibold py-2.5 px-4 rounded-xl text-white bg-gradient-to-r from-indigo-600 to-indigo-700 hover:shadow-lg transition-all" onClick={handleDispatch}>
                                Yes, Proceed
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    )
}

export default SingleOrderButtons;